const SizePerBox = Object.freeze({
  '25x75': 16,
  '50x75': 12,
  '111x75': 8,
  Custom: 8,
});

function estimateChipPerBox(quote) {
  if (quote.pricingVersion !== 'v3') {
    throw new Error('estimateChipPerBox is only supported for v3 quotes');
  }

  // Be able to manually override chipsPerBox
  if (Number.isInteger(quote.pricingV3?.values?.calculatedValues?.chipsPerBox)) {
    return quote.pricingV3.values.calculatedValues.chipsPerBox;
  }

  const formingSize = quote.pricingV3.values.attributes['Forming cost'].value;
  if (formingSize && SizePerBox[formingSize]) {
    return SizePerBox[formingSize];
  }

  const cappingSize = quote.pricingV3.values.attributes['Capping cost'].value;
  if (cappingSize && SizePerBox[cappingSize]) {
    return SizePerBox[cappingSize];
  }

  return 8;
}

function calculatePackageNumber(richItems) {
  if (!Array.isArray(richItems) || richItems.length === 0) {
    throw new Error('Input must be a non-empty array of cart items with quote and leadtimeDays information');
  }

  // Filter valid items: must have numeric quantity and a quote object
  const validItems = richItems.filter(
    (item) => typeof item.quantity === 'number'
      && item.quantity > 0
      && typeof item.quote === 'object'
      && item.quote !== null
      && (item.leadtimeDays > 0 || item.leadtimeText),
  );

  if (validItems.length === 0) {
    throw new Error('Each item must have a positive quantity, a quote object, and positive leadtime days');
  }

  // group by leadtimeDays, then group by size
  const groupedByLeadtime = validItems.reduce((acc, item) => {
    const leadtimeDays = item.leadtimeDays || item.leadtimeText;
    if (!acc[leadtimeDays]) {
      acc[leadtimeDays] = [];
    }
    acc[leadtimeDays].push(item);
    return acc;
  }, {});

  let boxCount = 0;
  // For each leadtime group, group by max chips per box
  Object.values(groupedByLeadtime).forEach((items) => {
    const sizeMap = {};
    items.forEach((item) => {
      const maxChipPerBox = estimateChipPerBox(item.quote);
      if (!sizeMap[maxChipPerBox]) {
        sizeMap[maxChipPerBox] = 0;
      }
      sizeMap[maxChipPerBox] += item.quantity;
    });
    Object.entries(sizeMap).forEach(([size, totalQuantity]) => {
      const itemBoxCount = Math.ceil(totalQuantity / size);
      boxCount += itemBoxCount;
    });
  });

  return boxCount > 0 ? boxCount : 1; // Ensure at least one package is returned
}

export {
  // eslint-disable-next-line import/prefer-default-export
  calculatePackageNumber,
};
